import { Button, VenueLogoList } from '@beat-venues/ui/react';
import { Container, Heading } from '@beat-venues/ui/subset';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

const NotFound = (): ReactElement => {
    const { t } = useTranslation();
    return (
        <Container className="mb-20 mt-20 text-center" maxWidth="lg">
            <Heading as="h1" className="xs:text-6xl mb-11" size="display">
                404
            </Heading>
            <Heading as="h3" className="xs:text-3xl mb-8">
                {t('404.message')}
            </Heading>
            <Button href="/">{t('404.buttonLabel')}</Button>
            <VenueLogoList includeBeat={false} />
        </Container>
    );
};

export { NotFound };
